import { Link, useLocation } from "@tanstack/react-router";
import { Icon } from "icons";
import { DropdownMenuItem } from "ui";

interface AccountMenuOrganizationItemProps {
  organization: {
    id: string;
    name: string;
    slug: string;
  };
}

export function AccountMenuOrganizationItem(
  props: AccountMenuOrganizationItemProps,
) {
  const pathname = useLocation({
    select: (location) => {
      return location.pathname;
    },
  });
  const organizationPath = `/orgs/${props.organization.slug}`;
  const isActive =
    pathname === organizationPath ||
    pathname.startsWith(`${organizationPath}/`);

  return (
    <DropdownMenuItem asChild>
      <Link
        to="/orgs/$slug"
        params={{ slug: props.organization.slug }}
        className="flex justify-between"
      >
        <span>{props.organization.name}</span>
        {isActive ? <Icon name="tabler-check" /> : null}
      </Link>
    </DropdownMenuItem>
  );
}
